// src/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("token") ||
  localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />; // if no token → go to login
  }

  return children;
};

export default ProtectedRoute;
